import { useEffect } from "react";

/** True when focus is in a field where "/" is a literal character. */
const isEditableTarget = (el: EventTarget | null): boolean => {
  if (!(el instanceof HTMLElement)) return false;
  const tag = el.tagName;
  return (
    tag === "INPUT" ||
    tag === "TEXTAREA" ||
    tag === "SELECT" ||
    el.isContentEditable
  );
};

/**
 * Opens global search when the user presses "/" anywhere outside a text field.
 * Mirrors GitHub/Slack. Cmd+K is intentionally NOT used — that belongs to Maya.
 */
export const useGlobalSearchHotkey = (onOpen: () => void, enabled = true) => {
  useEffect(() => {
    if (!enabled) return;

    const handler = (e: KeyboardEvent) => {
      if (e.key !== "/") return;
      // Let modifier combos (e.g. Cmd+/) pass through untouched.
      if (e.metaKey || e.ctrlKey || e.altKey) return;
      if (isEditableTarget(e.target)) return;

      e.preventDefault();
      onOpen();
    };

    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [onOpen, enabled]);
};
